// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../registration-vue/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div .bg-light-blue-alt[data-v-e5052dea]{background-color:#f0f4ff}", ""]);
// Exports
module.exports = exports;
